<template>
  <div class="w-100 h-100">
    <b-row>
      <b-col cols="12" md="4" xl="2">
        <Profile
          :user="localUser"
          :myAccount="myAccount"
          :isAdmin="isAdmin"
          :loadingMessages="loadingMessages"
          :edit="edit"/>
      </b-col>
      <b-col cols="12" md="8" xl="10">
        <div class="mb-4">
          <UserAccount
            v-if="!edit"
            :user="localUser"
            :plan="plan"
            :sub="sub"
            :forClient="forClient"
            :isSending="isSending"
            :isAdmin="isAdmin"
            :loadingMessages="loadingMessages"
            :loadingSubscriptions="loadingSubscriptions"
            v-on:toggleEdit="toggleEdit"
            v-on:handleSave="handleSave"/>
          <div v-else>
            <UserAccountAdminForm
              v-if="myAccount || isAdmin"
              :user="localUser"
              v-on:handleSave="handleSave"
              v-on:handleCancel="handleCancel"
              :isAdmin="isAdmin"
              :forClient="forClient"
              :myAccount="myAccount"/>
            <UserAccountForm
              v-else
              :user="localUser"
              v-on:handleSave="handleSave"
              v-on:handleCancel="handleCancel"
              :isAdmin="isAdmin"
              :forClient="forClient" />
          </div>
        </div>
        <b-row v-if="isAdmin || !forClient" class="mx-0">
          <b-col v-if="displaySurvey" cols="12" lg="6" xl="4" class="pl-0 pr-2 pb-4">
            <SurveyList v-if="!editSurvey" v-on:toggleSurvey="toggleSurvey" :forClient="forClient" :user="localUser"/>
            <SurveyForm v-else v-on:toggleSurvey="toggleSurvey" :user="localUser" />
          </b-col>
          <b-col cols="12" lg="6" xl="4" class="pl-0 pr-2 pb-4">
            <BiometricsList v-if="!editBiometrics" v-on:toggleBiometrics="toggleBiometrics" :forClient="forClient" :user="localUser" />
            <BiometricsForm v-else v-on:toggleBiometrics="toggleBiometrics" :user="localUser" />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'
import Profile from './Profile.vue'
import UserAccount from './UserAccount.vue'
import UserAccountAdminForm from './UserAccountAdminForm.vue'
import UserAccountForm from './UserAccountForm.vue'
import SurveyForm from '../Surveys/SurveyForm'
import SurveyList from '../Surveys/SurveyList'
import BiometricsForm from '../Biometrics/BiometricsForm'
import BiometricsList from '../Biometrics/BiometricsList'

export default {
  name: 'UserAccountContainer',
  components: { Profile, UserAccount, UserAccountAdminForm, UserAccountForm, SurveyForm, SurveyList, BiometricsForm, BiometricsList },
  props: ['user', 'sub', 'plan', 'forClient', 'loadingMessages', 'loadingSubscriptions'],
  data() {
    return {
      localUser: {},
      edit: false,
      isSending: false,
      editSurvey: false,
      editBiometrics: false
    }
  },
  computed: {
    ...mapGetters(['getMyInfo']),
    myAccount() { if (this.getMyInfo) return this.user._id === this.getMyInfo._id },
    isAdmin() { if (this.getMyInfo) return this.getMyInfo.hasRoles },
    displaySurvey() { if (this.user.surveys) return this.user.surveys.length > 0 }
  },
  methods: {
    ...mapActions([
      'doProfileUpdate',
      'doUserUpdate',
      'getParticipantInfo'
    ]),
    toggleEdit() { this.edit = !this.edit },
    toggleSurvey() { this.editSurvey = !this.editSurvey },
    toggleBiometrics() { this.editBiometrics = !this.editBiometrics },
    handleSave: async function (data) {
      this.isSending = true
      if (this.forClient) {
        await this.doUserUpdate(data)
        this.$emit('reloadPage')
      } else {
        await this.doProfileUpdate(data)
      }
      await this.getParticipantInfo(data)
      this.edit = !this.edit
      this.isSending = false
    },
    handleCancel() { this.edit = !this.edit }
  },
  mounted: async function () {
    this.localUser = await cloneDeep(this.user)
  },
  watch: {
    user: {
      handler: async function () {
        this.localUser = await cloneDeep(this.user)
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/UserAccount/UserAccountContainer.vue?3696da74